import { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";
import Icon from "../../../components/AppIcon";

const StatsAdmin = () => {
  const [form, setForm] = useState({
    totalStudents: 0,
    rating: 0,
    successRate: 0,
    trustedByCount: 0,
    expertCourses: 0
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // ✅ FETCH
  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get("/api/stats");
        if (res.data) setForm(res.data);
      } catch {
        alert("Failed to load stats");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // ✅ UPDATE
  const save = async () => {
    try {
      setSaving(true);
      await api.post("/api/stats/stats", form); // ✅ FIXED
      alert("Stats updated successfully");
    } catch (err) {
      alert(err.response?.data?.message || "Update failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="text-muted-foreground">Loading...</p>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Platform Statistics</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          { key: "totalStudents", label: "Total Students", icon: "Users" },
          { key: "rating", label: "Rating", icon: "Star" },
          { key: "successRate", label: "Success Rate (%)", icon: "TrendingUp" },
          { key: "trustedByCount", label: "Trusted By Companies", icon: "Shield" },
          { key: "expertCourses", label: "Expert Courses", icon: "BookOpen" }
        ].map(({ key, label, icon }) => (
          <div
            key={key}
            className="bg-card border border-border rounded-lg p-5"
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={icon} size={20} />
              </div>
              <h3 className="font-semibold">{label}</h3>
            </div>

            <input
              type="number"
              className="w-full border p-2 rounded"
              value={form[key] ?? 0}
              onChange={(e) =>
                setForm({ ...form, [key]: Number(e.target.value) })
              }
            />
          </div>
        ))}
      </div>

      <button
        onClick={save}
        disabled={saving}
        className="bg-primary text-white px-6 py-2 rounded"
      >
        {saving ? "Saving..." : "Save Stats"}
      </button>
    </div>
  );
};

export default StatsAdmin;
